/**
 * Billing account prepaid subview — the same five prepaid status stat cards
 * and coverage grid PrepaidDashboardView shows, scoped inline to the
 * account's customer instead of behind a customer picker. Routed at
 * `/billing/accounts/:accountId/prepaid`.
 *
 * Contains:
 * - AccountPrepaidView — routed child page (default export)
 */
import { Box } from '@mui/material';
import React, { useState } from 'react';

import { useBillingAccount } from '@sophocles/views/billing/BillingAccountLayout';
import {
  PREPAID_STATUS_CARD_COUNT,
  PrepaidCoverageGrid,
  PrepaidStatusCards,
} from '@sophocles/views/billing/components';

function AccountPrepaidView() {
  const { account } = useBillingAccount();
  const customerId = account?.customer?.id;

  const [statusFilter, setStatusFilter] = useState('');
  // Bumped by the grid's onDataChange so the cards recount after a write,
  // without the cards owning the grid's mutation lifecycle.
  const [reloadToken, setReloadToken] = useState(0);

  return (
    <>
      <Box sx={{ flexShrink: 0, px: 2, pt: 2 }}>
        <PrepaidStatusCards
          customerId={customerId}
          requireCustomerId
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          reloadToken={reloadToken}
          columns={{ xs: 2, sm: 3, md: 3, lg: PREPAID_STATUS_CARD_COUNT }}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, px: 2, pb: 2 }}>
        <PrepaidCoverageGrid
          customerId={customerId}
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          onDataChange={() => setReloadToken(token => token + 1)}
        />
      </Box>
    </>
  );
}

export default AccountPrepaidView;
